export const _gerPrefix = (fName = "", lName = "") => {
    return `${fName[0] || ""}${lName[0] || ""}`;
  };